import React from 'react';
import TableCell from '@mui/material/TableCell';
import MuiTableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import modalities from '@core/constants/modalities';
import ReferrerColumn from '../RefererrerColumn';
import useSx from './sx';

type Props = {
  onOrderChange: (order: string) => void;
};

const TableHead = ({ onOrderChange }: Props) => {
  const sx = useSx();

  return (
    <MuiTableHead>
      <TableRow sx={sx.root}>
        <ReferrerColumn onOrderChange={onOrderChange} />
        <TableCell align="center">Todas las modalidades</TableCell>
        {modalities.map((modality, index) => (
          <TableCell key={modality + index} align="center">
            {modality}
          </TableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  );
};

export default TableHead;
